import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {AdditionalField} from "../../../shared/interface/additionalField";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Profile} from "../../../shared/interface/profile";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {FacilityService} from "../../../shared/services/facility.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {AdditionalFieldsService} from "../../../shared/services/additional-fields.service";
import {takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-additional-fields-details-view',
  templateUrl: './additional-fields-details-view.component.html',
  styleUrls: ['./additional-fields-details-view.component.scss']
})
export class AdditionalFieldsDetailsViewComponent implements OnInit, OnDestroy {

  @Input() additionalField: Observable<AdditionalField>;
  @Output() modifyClicked = new EventEmitter<void>();

  additionalFieldObject?: AdditionalField;
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private additionalFieldService: AdditionalFieldsService,
    private facilityService: FacilityService,
    private snack: MatSnackBar,
    private router: Router
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.additionalField
      .pipe(takeUntil(this.destroyed$))
      .subscribe((additionalField: AdditionalField) => {
        this.additionalFieldObject = additionalField;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć pole dodatkowe?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.additionalFieldService.deleteAdditionalField(this.additionalFieldObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto pole dodatkowe', '', {duration: 2000});
            this.router.navigate(['/wyniki-konkursow/pola-dodatkowe']);
          });
      }
    });
  }

}
